<template>
  <div class="award" style="width:131px; line-height:0px; padding:0px">
    <img :src="imgTop">
    <a target="_blank" href="https://www.afristay.com/p/30710?guests=1&amp;rooms=None">
      <img alt="Roodepoort self catering" :src="imgBottom">
    </a>
    <div class="bc-white text-align-center">
      Wisteria Lodge in Roodepoort received a 2018 Best Value Destination Award.
    </div>
  </div>
</template>

<script>
import imgTop from '@/assets/images/award/award-top.png'
import imgBottom from '@/assets/images/award/award-bottom.png'

export default {
  name: 'Award',
  data () {
    return {
      imgTop: imgTop,
      imgBottom: imgBottom
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/Award.vue